// @flow

import * as React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { Row, Col, Form, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import classnames from 'classnames';
import Analyse from '../../../../Model/Analyse';
import BasicTab from './BasicTab'
import ReferenzwertTab from './ReferenzwertTab'
import LaborTab from './LaborTab/index'
import MaterialTab from './MaterialTab/index'
import VersandTab from './VersandTab/index'

type Props = {
  analyse: Analyse,
};

@observer
export default class AnalyseForm extends React.Component<Props, void> {
  
  @observable activeTab: string = 'basic';
  
  toggleTab = (activeTab: string): void => {
    if (this.activeTab !== activeTab) {
      this.activeTab = activeTab;
    }
  };

  render() {
    const { analyse } = this.props;
    const { activeTab } = this;

    return (
      <Row>
        <Col>
          <Nav tabs className="d-print-none">
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === 'basic' })}
                onClick={() => { this.toggleTab('basic'); }}
              >
                Allg. Daten
              </NavLink>
            </NavItem>
            { analyse.hasReferenzwert ? (
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === 'referenzwert' })}
                  onClick={() => { this.toggleTab('referenzwert'); }}
                >
                  Referenzwert
                </NavLink>
              </NavItem>
            ) : null}
          </Nav>
          <TabContent activeTab={activeTab}>
            <TabPane tabId={'basic'}>
              <BasicTab analyse={analyse}/>
            </TabPane>
            <TabPane tabId={'referenzwert'}>
              <ReferenzwertTab analyse={analyse}/>
            </TabPane>
          </TabContent>
        </Col>
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/Views/Analysis/View/AnalyseForm/index.js